import { useAuth } from '@/context/Auth';
import { useContact } from '@/context/Contact';
import { useMemo } from 'react';

/**
 * Hook that determines if a user is fully authenticated in the application
 * @returns {Object} Object containing isAuthenticated boolean
 */
export const useIsAuthenticated = (): { isAuthenticated: boolean } => {
  const { isForbidden: isContactForbidden } = useContact();
  const { isAuthorized, isAuthorizing } = useAuth();

  const isAuthenticated = useMemo(() => {
    return !!isAuthorized && !isAuthorizing && !isContactForbidden;
  }, [isAuthorized, isAuthorizing, isContactForbidden]);

  return { isAuthenticated };
};
